import { render, staticRenderFns } from "./PreRegisComplete.vue?vue&type=template&id=41885d3a&scoped=true"
import script from "./PreRegisComplete.vue?vue&type=script&lang=js"
export * from "./PreRegisComplete.vue?vue&type=script&lang=js"
import style0 from "./PreRegisComplete.vue?vue&type=style&index=0&id=41885d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41885d3a",
  null
  
)

export default component.exports